import React, { useEffect, useState } from "react";

import Navbar from "../../Components/Navbar";
import ProjectLeftCard from "../../Components/ProjectLeftCard";
import ProjectRightCard from "../../Components/ProjectRightCard";
import RevealText from "../../Components/RevealText";
import projectDBData from "../../DB/Allprojects.json";
import { Resume_builder_banner , narrateMediaBanner,project_mockup1,MedibaiBanner,AstrattoBanner , project2_banner , crypto_app_banner , table_schulte_game_banner } from "../../Assets";

const ProjectShowCase = () => {
  const [projectData, setProjectData] = useState([]);

  const bannerImgs = [
    AstrattoBanner,
    narrateMediaBanner,
    project_mockup1,
    Resume_builder_banner ,
    project2_banner,
    table_schulte_game_banner ,
 
    // MedibaiBanner
  ]

  

  useEffect(() => {
    setTimeout(() => {
      setProjectData(projectDBData.projects);
    }, 1000);

    console.log(projectData)
  }, []);

  return (
    <>
      <div className="app-main-wrapper">
        <div className="projects-showcase-main-cover-wrapper">
          <div className="container">
            <div className="projects-showcase-main-cover">
              <div className="projects-showcase-title-box">
                <RevealText text=" Discover My Diverse Projects Gallery" />
              </div>
              <div className="projects-showcase-content-cover">
                <div className="main-line-box"></div>
                <div>
                  {projectData.map((project, index) => {
                    if (index % 2 === 0) {
                      return (
                        <div className="project-showcase-inner-cover mb-4" key={index}>
                          <span className="inner-line"></span>
                          <ProjectLeftCard
                            key={project.id}
                            ind={index}
                            name={project.name}
                            bannerimg={bannerImgs[index]}
                            bgColor={project.bg_color}
                            liveLink={project.live_link}
                          />
                          {projectData[index + 1] && (
                            <ProjectRightCard
                              name={projectDBData?.projects[index + 1].name}
                              index={index + 1}
                              key={projectDBData.projects[index + 1].id}
                              bannerimg={bannerImgs[index + 1]}
                              bgColor={projectDBData?.projects[index + 1].bg_color}
                              liveLink={projectDBData?.projects[index + 1].live_link}
                            />
                          )}
                          {/* {console.log(projectDBData.projects[index + 1] , "tests")} */}
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectShowCase;
